(function () {
    let cartRefreshInProgress = false;

    async function refreshPortoCart() {
        if (cartRefreshInProgress) return;

        cartRefreshInProgress = true;

        try {
            /*
             * 1. Get the current cart and update the blue quantity badge.
             */
            const cartResponse = await fetch(
                (window.Shopify?.routes?.root || '/') + 'cart.js',
                {
                    headers: {
                        Accept: 'application/json'
                    },
                    cache: 'no-store'
                }
            );

            if (!cartResponse.ok) {
                throw new Error('Unable to retrieve the cart.');
            }

            const cart = await cartResponse.json();

            document.querySelectorAll('.cart-qty').forEach(function (element) {
                element.textContent = cart.item_count;
            });

            /*
             * 2. Fetch a fresh copy of the current page.
             * Shopify renders the mini-cart with the latest cart contents.
             */
            const pageResponse = await fetch(window.location.href, {
                headers: {
                    Accept: 'text/html'
                },
                cache: 'no-store'
            });

            if (!pageResponse.ok) {
                throw new Error('Unable to refresh the mini cart.');
            }

            const html = await pageResponse.text();
            const parsedPage = new DOMParser().parseFromString(
                html,
                'text/html'
            );

            /*
             * Porto releases may use different names for the mini-cart
             * container. The first matching selector will be refreshed.
             */
            const possibleSelectors = [
                '.mini-cart',
                '.header-cart',
                '.cart-dropdown',
                '.cart-popup',
                '.mini-cart-wrapper',
                '.mini-cart-content',
                '[data-cart-dropdown]'
            ];

            let miniCartUpdated = false;

            for (const selector of possibleSelectors) {
                const currentMiniCart = document.querySelector(selector);
                const refreshedMiniCart = parsedPage.querySelector(selector);

                if (currentMiniCart && refreshedMiniCart) {
                    currentMiniCart.innerHTML = refreshedMiniCart.innerHTML;
                    miniCartUpdated = true;
                    break;
                }
            }

            if (!miniCartUpdated) {
                console.warn(
                    'Porto mini-cart container was not found. ' +
                    'Inspect the cart dropdown to identify its outer selector.'
                );
            }

            document.dispatchEvent(
                new CustomEvent('porto:cart-refreshed', {
                    detail: { cart: cart }
                })
            );
        } catch (error) {
            console.error('Porto cart refresh failed:', error);
        } finally {
            cartRefreshInProgress = false;
        }
    }

    window.refreshPortoCart = refreshPortoCart;

    document.addEventListener('DOMContentLoaded', refreshPortoCart);

    /*
     * Watch AJAX requests made by PageFly or Porto.
     */
    const originalFetch = window.fetch;

    window.fetch = async function () {
        const response = await originalFetch.apply(this, arguments);

        const request = arguments[0];
        const url =
            typeof request === 'string'
                ? request
                : request && request.url
                    ? request.url
                    : '';

        const isCartMutation =
            /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url);

        if (response.ok && isCartMutation) {
            window.setTimeout(refreshPortoCart, 200);
        }

        return response;
    };
})();
